function useEmployeePerformanceAssessmentResults() {
  return {};
}

export default useEmployeePerformanceAssessmentResults;
